import {Component} from '@angular/core';
import {LanguageService} from '../services/language.service';
import {languagesAndFlags} from '../util/flags';
import {UtDropdownMenuComponent, UtDropdownItem} from '../ui';

@Component({
  selector: 'app-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
  imports: [UtDropdownMenuComponent],
})
export class LanguageSwitchComponent {
  availableLanguages = languagesAndFlags;

  readonly items: UtDropdownItem[] = this.availableLanguages.map((l) => ({
    label: this.labelFor(l.language),
    key: l.language,
  }));

  constructor(private languageService: LanguageService) {}

  get lang(): string {
    return this.languageService.language;
  }

  set lang(lang: string) {
    this.languageService.language = lang;
  }

  onSelected(item: UtDropdownItem): void {
    if (item.key) {
      this.lang = item.key;
    }
  }

  getFlagFor(lang: string): string | undefined {
    return this.availableLanguages?.find((al) => al.language === lang)?.flag;
  }

  private labelFor(lang: string): string {
    switch (lang) {
      case 'en':
        return 'English';
      case 'fr':
        return 'Français';
      case 'de':
        return 'Deutsch';
      case 'zh':
        return '中文';
      case 'es':
        return 'Español';
      case 'nl':
        return 'Nederlands';
      default:
        return lang;
    }
  }
}
